import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FeatureScopeActions } from './feature-scope.actions';
import { FeatureScopeSelectors } from './feature-scope.selectors';
import {CoreStoreService} from '@emm/core/store/core-store.service';
import {State} from '@emm/auth/store/auth.reducer';

export interface FeatureScopeQueries {
    selected$: Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class FeatureScopeStoreService extends CoreStoreService  {

    constructor(store: Store<State>) {
        super(store);
    }

    dispatch = {
        selectFeatureScope: (scope: string) =>
            this.store.dispatch(FeatureScopeActions.select({ scope }))
    };

    queries: FeatureScopeQueries = {
        selected$: this.select(FeatureScopeSelectors.getSelectedScope),
    };

}
